<template>
    <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle waves-effect waves-dark" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img :src="profile ? profile.picture : ''" class="profile-pic" /></a>
        <div class="dropdown-menu dropdown-menu-right">
            <ul class="dropdown-user">
                <li>
                    <div class="dw-user-box" v-if="profile">
                        <div class="u-img"><img :src="profile.picture" alt="profile"></div>
                        <div class="u-text">
                            <h4>{{profile.name}}</h4>
                            <p class="text-muted">{{profile.nickname}}</p>
                            <p class="text-muted">{{$t('gebruiker.gebruiker')}}</p>
                        </div>
                    </div>
                </li>
                <li role="separator" class="divider"></li>
                <li><a style="cursor:pointer" @click="logout()" ><i class="fa fa-power-off"></i> {{$t('gebruiker.uitloggen')}}</a></li>
            </ul>
        </div>
    </li>
</template>

<script>
export default {
  data() {
    return {
      profile: this.$auth.profile
    };
  },
  methods: {
    logout() {
      this.$auth.logOut();
      this.$router.push({ name: "index" });
    },
    handleLoginEvent(data) {
      this.profile = data.profile;
    }
  }
};
</script>
